import { render, staticRenderFns } from "./TradingGroups.vue?vue&type=template&id=84df19bc&scoped=true"
import script from "./TradingGroups.vue?vue&type=script&lang=js"
export * from "./TradingGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84df19bc",
  null
  
)

export default component.exports